import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BannerHeader = ({ title, subtitle, text, headerStyle, colourScheme }) => {
  const componentClasses = classNames('banner-header', {
    [`banner-header--${headerStyle}`]: headerStyle,
    [`banner-header--${colourScheme}-scheme`]: colourScheme
  });

  return (
    <header className={componentClasses}>
      <h1 className="banner-header__title">{title}</h1>
      {subtitle && <p className="banner-header__subtitle">{subtitle}</p>}
      {text && <p className="banner-header__text">{text}</p>}
    </header>
  );
};

BannerHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  colourScheme: PropTypes.oneOf(['white', 'dark-navy', 'neutral-navy', 'neutral-purple']),
  headerStyle: PropTypes.oneOf(['for-blog'])
};

export default BannerHeader;
